import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from "react";
import { AlertDialog } from "./AlertDialog";
const AlertDialogContext = createContext(undefined);
export const useAlert = () => {
    const context = useContext(AlertDialogContext);
    if (!context) {
        throw new Error("useAlert must be used within AlertDialogProvider");
    }
    return context;
};
export const AlertDialogProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [options, setOptions] = useState(null);
    const [resolvePromise, setResolvePromise] = useState(null);
    const showAlert = useCallback((alertOptions) => {
        return new Promise((resolve) => {
            setOptions(alertOptions);
            setIsOpen(true);
            setResolvePromise(() => resolve);
        });
    }, []);
    const showConfirm = useCallback((message, title, options) => {
        return showAlert({
            message,
            title,
            type: "confirm",
            confirmText: options?.confirmText || "Confirm",
            cancelText: options?.cancelText || "Cancel",
        });
    }, [showAlert]);
    const handleClose = useCallback((confirmed) => {
        setIsOpen(false);
        if (resolvePromise) {
            resolvePromise(confirmed);
            setResolvePromise(null);
        }
        setTimeout(() => {
            setOptions(null);
        }, 300);
    }, [resolvePromise]);
    const value = {
        showAlert,
        showConfirm,
    };
    return (_jsxs(AlertDialogContext.Provider, { value: value, children: [children, _jsx(AlertDialog, { isOpen: isOpen, options: options, onClose: handleClose })] }));
};
